import { render, staticRenderFns } from "./Fisherman.vue?vue&type=template&id=24c762e8&scoped=true"
import script from "./Fisherman.vue?vue&type=script&lang=js"
export * from "./Fisherman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c762e8",
  null
  
)

export default component.exports